const isZeno = JSON.parse(process.env.VUE_APP_FEATURE_ZENOTOOLS)
const isAiir_Nistar = process.env.VUE_APP_NAME === "Aiir" || process.env.VUE_APP_NAME === "NistarAds"
const hasSubscriptions = isZeno || isAiir_Nistar
// Product choice, not a backend limit: the API takes any non-blank name up to 255 characters. Aiir only needs "required".
const stationNameMinLength = { Aiir: 1, SurferNETWORK: 4 }[process.env.VUE_APP_NAME] || 6

let config = {
  appName: process.env.VUE_APP_NAME,
  isDevelopment: process.env.NODE_ENV === "development",
  isAiir: process.env.VUE_APP_NAME === "Aiir",
  isAiir_Nistar,
  appLogo: process.env.VUE_APP_LOGO,
  isStationAlertsEnabled: process.env.VUE_APP_STATION_ALERTS_ENABLED === "true",
  isRecordPodcastEnabled: process.env.VUE_APP_RECORD_PODCAST_ENABLED === "true",
  isImportPodcastEnabled: process.env.VUE_APP_IMPORT_PODCAST_ENABLED === "true",
  isCreateNewPodcastEnabled: process.env.VUE_APP_CREATE_PODCAST_ENABLED === "true",
  defaultPodcastCreationMethod: process.env.VUE_APP_DEFAULT_PODCAST_CREATION_METHOD,
  isDeleteOwnAccountEnabled: process.env.VUE_APP_DELETE_OWN_ACCOUNT_ENABLED === "true",
  isZeno,
  isSurferNetwork: process.env.VUE_APP_NAME === "SurferNETWORK",
  // Brands with Stripe commerce: a checkout exists to send users to, and plans define quotas.
  // Also picks how PodcastBot is offered — see FeatureFlags/isPodcastBotUpsell and isPodcastBotCreationMethod.
  hasSubscriptions,
  stationNameMinLength,
  colors: {
    primary: process.env.VUE_APP_THEME_COLOR_PRIMARY,
    primaryLight: process.env.VUE_APP_THEME_COLOR_PRIMARY_LIGHT,
    success: process.env.VUE_APP_THEME_COLOR_SUCCESS,
    danger: process.env.VUE_APP_THEME_COLOR_DANGER,
    warning: process.env.VUE_APP_THEME_COLOR_WARNING,
  },
  automation: JSON.parse(process.env.VUE_APP_FEATURE_AUTOMATION),
  // converting podcast episodes to MP3 (tools-service's PODCAST_TRANSCODE_ENABLED too); unset: off, "coming soon"
  podcastTranscode: process.env.VUE_APP_FEATURE_PODCAST_TRANSCODE === "true",
  libreTimeUrl: process.env.VUE_APP_LIBRETIME_URL,
  nowPlayingEventSourceURL: process.env.VUE_APP_NOW_PLAYING_EVENT_SOURCE_URL,
  speedtestHost: (process.env.VUE_APP_SPEEDTEST_HOST || "").trim(),
  imageProxyURL: process.env.VUE_APP_IMAGE_PROXY_URL,
  podcastFeedURL: process.env.VUE_APP_PODCAST_FEED_URL,
  copyrightText: process.env.VUE_APP_COPYRIGHT_TEXT,
  copyrightURL: process.env.VUE_APP_COPYRIGHT_URL,
  termsText: process.env.VUE_APP_TERMS_TEXT,
  termsURL: process.env.VUE_APP_TERMS_URL,
  // ads.txt help article and support contact shown on the station ads.txt page; override per brand.
  adsTxtHelpUrl:
    process.env.VUE_APP_ADS_TXT_HELP_URL || "https://help.zeno.fm/en/article/setting-up-adstxt-in-zeno-tools-qzrm70/",
  supportEmail: process.env.VUE_APP_SUPPORT_EMAIL || "support@zenomedia.com",
  isPlanCustomStationsEnabled: process.env.VUE_APP_STRIPE_SUBSCRIPTION_ACCOUNT_CUSTOM_STATIONS_ENABLED
    ? JSON.parse(process.env.VUE_APP_STRIPE_SUBSCRIPTION_ACCOUNT_CUSTOM_STATIONS_ENABLED)
    : false,
  // Plan changes and campaign claims through our own preview/update endpoints instead of the Stripe
  // billing portal. Off until the backend's test-mode scenarios have passed end to end.
  isPlanChangeApiEnabled: process.env.VUE_APP_PLAN_CHANGE_API_ENABLED === "true",
  // Offers shown before a plan is cancelled. Each stays hidden until its setting is on, and is then shown only
  // where the Tools Service says it's available (pauseAvailable, retentionOfferAvailable).
  isSubscriptionPauseEnabled: process.env.VUE_APP_SUBSCRIPTION_PAUSE_ENABLED === "true",
  isRetentionAnnualOfferEnabled: process.env.VUE_APP_RETENTION_ANNUAL_OFFER_ENABLED === "true",
}

export { config }
